import { getType, Types } from "utils/TypeHelpers";
import AppsmithConsole from "utils/AppsmithConsole";
import { isBase64String, isUrlString } from "./downloadActionUtils";
import { isBlobUrl } from "utils/AppsmithUtils";

const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB

function convertBlobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    // Check file size
    if (blob.size > MAX_FILE_SIZE) {
      reject(new Error(`File size exceeds maximum limit of ${MAX_FILE_SIZE / (1024 * 1024)}MB`));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];
      if (base64) {
        resolve(base64);
      } else {
        reject(new Error("Failed to extract base64 from FileReader result"));
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(blob);
  });
}

export default async function convertToBase64Saga(action: any) {
  try {
    const { payload } = action;
    const { data, type } = payload;

    let base64Result: string;

    if (isBlobUrl(data)) {
      const response = await fetch(data);
      const blob = await response.blob();
      base64Result = await convertBlobToBase64(blob);
    } else if (data instanceof Blob) {
      base64Result = await convertBlobToBase64(data);
    } else if (isUrlString(data)) {
      const response = await fetch(data);
      const blob = await response.blob();
      base64Result = await convertBlobToBase64(blob);
    } else if (isBase64String(data)) {
      base64Result = data;
    } else if (getType(data) === Types.ARRAY || getType(data) === Types.OBJECT) {
      const jsonString = JSON.stringify(data, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      base64Result = await convertBlobToBase64(blob);
    } else {
      const blob = new Blob([String(data)], { type: type || 'text/plain' });
      base64Result = await convertBlobToBase64(blob);
    }

    const result = {
      base64: base64Result,
      type: type || 'text/plain'
    };
  
    AppsmithConsole.info({
      text: `convertToBase64('${type || 'text/plain'}') was triggered`,
    });
  
    return result;
  } catch (error) {
    console.error("convertToBase64Saga - Error:", error);
    throw error;
  }
}